import type { ReactNode, CSSProperties } from 'react'
import css from './ButtonRound.module.css'
import { TextNorm } from '../Text'

interface ButtonRoundProps {
    children: ReactNode
    icon?: ReactNode
    color?: string
    ghost?: boolean
    disabled?: boolean
    onClick?: () => void
    testId?: string
}

const ButtonRound = ({ children, icon, color, ghost = false, disabled = false, onClick, testId }: ButtonRoundProps) => {
    const className = [
        css.button,
        color && css.colored,
        ghost && css.ghost,
        disabled && css.disabled
    ].filter(Boolean).join(' ')

    const style: CSSProperties | undefined = color ? {
        '--button-color': color
    } as CSSProperties : undefined

    const handleClick = () => {
        if (onClick && !disabled) {
            onClick()
        }
    }

    return (
        <button className={className} style={style} disabled={disabled} onClick={handleClick} data-testid={testId}>
            {icon && <span className={css.icon}>{icon}</span>}
            <TextNorm>{children}</TextNorm>
        </button>
    )
}

export default ButtonRound
